{
  "expandedStatuses": ["To Do", "Not Started", "In Progress"],
  "sorting": [
    { "column": "To Do", "field": "DueDateTime", "order": "asc" },
    { "column": "In Progress", "field": "DueDateTime", "order": "asc" },
    { "column": "Done", "field": "CompletedDateTime", "order": "des" },
    { "column": "Not Started", "field": "DueDateTime", "order": "asc" },
    { "column": "Cancelled", "field": "CompletedDateTime", "order": "asc" },
    { "column": "Finished", "field": "CompletedDateTime", "order": "des" }
  ],
  "filtering": [
    {
      "column": "To Do",
      "label": "Upcoming",
      "selected": "7",
      "order": "after",
      "options": ["1", "7", "30", "90", "1y", "all"]
    },
    {
      "column": "Not Started",
      "label": "Upcoming",
      "selected": "30",
      "order": "after",
      "options": ["7", "30", "90", "1y", "all"]
    },
    {
      "column": "Done",
      "label": "Past",
      "selected": "7",
      "order": "before",
      "options": ["1", "7", "30", "90", "1y"]
    },
    {
      "column": "Finished",
      "label": "Past",
      "selected": "7",
      "order": "before",
      "options": ["1", "7", "30", "90", "1y"]
    }
  ],
  "statusNameMap": {
    "FILL": "Done",
    "EMPTY": "To Do",
    "IN_PROGRESS": "In Progress",
    "CANCELLED": "Cancelled",
    "FINISH": "Finished",
    "EMPTY_BUSINESS": "Not Started"
  },
  "showInDeletePopup": ["To Do", "In Progress", "Done"],
  "daysToMarkAsComingSoon": "7",
  "emptyState": [
    { "column": "To Do", "description": "Clear the search field." },
    { "column": "In Progress", "description": "Create new or clear the filter." },
    { "column": "Done", "description": "Change the date ranges." }
  ]
}
